export const CONFIGURATION = {
  student: {
    profile: {
      preferences: true
    }
  }
}